import React from 'react';
import { Autocomplete, Box, CircularProgress, TextField, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAuthors } from '../../actions/authorsActions';

const AuthorSelector = ({
  value,
  onChange,
  required = false,
  label = "Author",
  fullWidth = true,
  size = "medium"
}) => {
  const dispatch = useDispatch();
  const authors = useSelector(store => store.authors.authors);
  const isLoading = useSelector(store => store.authors.loading);

  React.useEffect(() => {
    if (!authors) {
      dispatch(fetchAuthors());
    }
  }, [dispatch, authors]);

  const renderAuthors = () => {
    if (!authors) return [];
    return authors.map((obj) => ({
      label: obj.author_name,
      value: obj.author_id,
      image: obj.author_image
    }));
  };

  const findOptionByValue = (options, value) => {
    if (!value) return null;
    return options.find(option => Number(option.value) === Number(value)) || null;
  };

  return (
    <Autocomplete
      fullWidth={fullWidth}
      options={renderAuthors()}
      getOptionLabel={(option) => option.label}
      value={findOptionByValue(renderAuthors(), value)}
      onChange={(_, newValue) => {
        onChange(newValue ? Number(newValue.value) : 0);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          required={required}
          sx={{
            '& .MuiInputBase-input': {
              paddingTop: '3px !important',
              paddingBottom: '3px !important',
            }
          }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
          size={size}
        />
      )}
      renderOption={(props, option) => (
        <li {...props} key={`${option.value}`}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {option.image && (
              <Box
                component="img"
                src={option.image}
                alt={option.label}
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: '50%',
                  objectFit: 'cover'
                }}
              />
            )}
            <Typography>{option.label}</Typography>
          </Box>
        </li>
      )}
      loading={isLoading}
      loadingText="Loading authors..."
      noOptionsText="No authors found"
    />
  );
};

export default AuthorSelector; 